import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

import { IN_PROGRESS, COMPLETED } from '../constants/challengeStatusTypes';

function getShareMessageKey(hasEntered, statusId) {
  if (!hasEntered) {
    return 'notEntered';
  }

  if (statusId === COMPLETED) {
    return 'enteredAndCompleted';
  }

  if (statusId >= IN_PROGRESS) {
    return 'enteredAndInProgress';
  }

  return 'enteredAndOpen';
}

const shareMessageKeySelector = createSelector(
  get('challenge.hasEntered'),
  get('challenge.statusId'),
  getShareMessageKey
);

const shareMessageSelector = createSelector(
  get('settings.social.messages'),
  shareMessageKeySelector,
  (messages, key) => messages[key]
);

export default shareMessageSelector;
